module.exports = __webpack_public_path__ + "img/user.e3155cb4.svg";